export default "__VITE_ASSET__CtvsBC6k__"